import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M19 22H5C4.44772 22 4 21.5523 4 21V11.357C4.01549 11.1119 4.11964 10.8809 4.293 10.707L11.293 3.70698C11.4806 3.51921 11.7351 3.4137 12.0005 3.4137C12.2659 3.4137 12.5204 3.51921 12.708 3.70698L19.708 10.707C19.8957 10.8943 20.0009 11.1488 20 11.414V21C20 21.5523 19.5523 22 19 22ZM12 5.82798L6 11.828V20H18V11.828L12 5.82798ZM9.878 18.071L8.465 16.657L10.586 14.536L8.465 12.414L9.879 11L12 13.121L14.121 11L15.535 12.414L13.414 14.535L15.535 16.656L14.122 18.069L12 15.949L9.879 18.071H9.878Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "HomeAltX"
);
